import React from 'react'

function AddSparkIcon() {
  return (
    <svg
      width='30'
      height='30'
      viewBox='0 0 30 30'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle
        cx='15'
        cy='15'
        r='14.5'
        fill='#ECEFFE'
        stroke='#6267AC'
      />
      <path
        d='M15.0003 9.1665V20.8332M9.16699 14.9998H20.8337'
        stroke='#6267AC'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default AddSparkIcon
